import { createAction } from 'redux-actions'

export const clearActivity = createAction('CLEAR_ACTIVITY')
export const clearActivityTimes = createAction('CLEAR_ACTIVITY_TIMES')

export const clearTickets = createAction('CLEAR_TICKETS')
export const deleteOrder = createAction('DELETE_ORDER')